<script>
  export let title = "";
</script>

<div class="main-title">
  <h2>{title}</h2>
</div>
